import * as R from 'ramda';
import { useQuery } from '@cd/react-query';
import { postJSONPS } from '@cd/utils';
import { either } from '@cd/utils';

export default function useInvoices(dispatch) {
	return useQuery('useInvoicesRoot', () =>
		postJSONPS('GET', '/invoice/list/all').then(
			either(e => {
				dispatch({ type: 'post error', e });
				throw new Error(e);
			}, R.identity)
		)
	);
}
